<template>
    <div class="DocsBox">
        <h1>Docs</h1>
        <div class="docs">

            <div v-for="(type,idx) in types" v-bind:key="idx">
                <h2 v-b-toggle="'accordion-' + idx">{{ type.entityName }}</h2>
                <b-collapse :id="'accordion-' + idx" class="collapsed">

                    <div v-for="(method,idm) in type.allowedMethods" v-bind:key="idm" class="methods">
                        <div class="urls" v-for="(url,idu) in method.urls" v-bind:key="idu">
                            <p>
                                <b v-if="method.name == 'get'" class="get">{{ method.name }}</b>
                                <b v-if="method.name == 'post'" class="post">{{ method.name }}</b>
                                <b v-if="method.name == 'put'" class="put">{{ method.name }}</b>
                                <b v-if="method.name == 'delete'" class="delete">{{ method.name }}</b>
                                {{ url }}</p>
                        </div>
                    </div>

                    <div v-for="(fieldje,idv) in type.fields" v-bind:key="idx+''+idv" class="fields">
                        <h3>Field: {{ fieldje.Field }}</h3>
                        <div class="field">
                            Type: {{ fieldje.Type }}, Null: {{ fieldje.Null }}, Extra: {{ fieldje.Extra }}
                        </div>
                    </div>

                </b-collapse>


            </div>

        </div>

    </div>
</template>

<style lang="scss">

    .DocsBox {
        padding: 0px;
        text-align: left;
        /*height: 50vh;*/
        /*overflow: hidden;*/
        /*overflow-y: scroll;*/

        h1{
            padding: 10px 20px;

        }

        h2 {
            margin: 0px;
            font-size: 120%;
            font-weight: bold;
            border-bottom: 1px solid #eeeeee;
            padding: 10px 20px;

            &:hover,
            &.active {
                background-color: #11caeb;
                color: #ffffff;
            }
        }

        h3 {
            font-size: 110%;
        }

        .collapsed {
            padding: 10px 20px;

            .fields{
                margin-bottom:10px;
                background-color: antiquewhite;
                .field{
                    font-size: 80%;
                }
            }
            .urls {
                p {
                    b {
                        padding: 2px 6px;
                        border-radius: 5px;
                        color: #fff;

                        &.get {
                            background-color: #2fb445;
                        }

                        &.post {
                            background-color: #4097b4;
                        }

                        &.put {
                            background-color: #c9b41b;
                        }

                        &.delete {
                            background-color: #b42116;
                        }
                    }

                    font-size: 90%;
                }
            }
        }
    }
</style>

<script>
    import TableauxApi from "../scripts/TableauxApi";

    var questionBox = {
        name: "Docs",
        data: function () {
            return {
                types: []
            }
        },
        created: function () {
            let $this = this;
            TableauxApi.set("GET").execute().then((result) => {
                let myloop = result.enabledEntities;
                window.console.log(myloop);
                for (let [, value] of Object.entries(myloop)) {
                    $this.types.push(value);
                }
            });
        }
    };

    export default questionBox;
</script>